import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "body2-text" };
import { initAutoLc } from '@/locales/ko/views/list_control';
import vuexStore from '@/vuex-store';
import { listControlActionType } from '@/vuex-store/list-control/actions';
import { modalOrderInfoActionType } from '@/vuex-store/modal-order-info/actions';
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ContextMenu',
    setup(__props) {
        const lc = initAutoLc();
        const isOpenMenu = computed(() => vuexStore.state.listControl.contextMenu.isOpen);
        const cssPosition = computed(() => {
            const { event } = vuexStore.state.listControl.contextMenu;
            if (!event) {
                return {};
            }
            return {
                position: 'fixed',
                top: `${event?.clientY}px`,
                left: `${event.clientX}px`,
            };
        });
        /**
         * 배차 다이얼로그
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const handleClickAllocate = () => {
            // const { orderId } = vuexStore.state.listControl.contextMenu;
            // const orderItem = vuexStore.state.listControl.orderList[orderId];
            // vuexStore.dispatch(workerAllocateActionType.setSelectedOrder, orderItem);
            // vuexStore.dispatch(workerAllocateActionType.dialogOpen);
        };
        /**
         * 주문 상세 보기 클릭 핸들러
         */
        const handleClickOrderInfo = () => {
            const { orderId } = vuexStore.state.listControl.contextMenu;
            vuexStore.dispatch(modalOrderInfoActionType.setIsOpenModalOrderInfo, orderId);
        };
        /**
         * 모델 업데이트 핸들러
         */
        const handleUpdateModel = (value) => {
            vuexStore.dispatch(listControlActionType.toggleContextMenu, {
                isOpen: value,
            });
        };
        /**
         * 우클릭 메뉴 리스트
         */
        const menuData = [
            {
                icon: 'mdi-text-box-edit-outline',
                title: lc('contextmenu.order_info'),
                eventHandler: handleClickOrderInfo,
                // 우클릭시 메뉴가 나올지 말지 판단되는 부분
                predicate: () => { },
            },
            {
                icon: 'mdi-face-man',
                title: lc('contextmenu.worker_info'),
                eventHandler: () => { },
                predicate: () => { },
            },
            {
                icon: 'mdi-moped',
                title: lc('contextmenu.allocate'),
                eventHandler: handleClickAllocate,
                predicate: () => { },
            },
        ];
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_list_item = _resolveComponent("v-list-item");
            const _component_v_list = _resolveComponent("v-list");
            const _component_v_menu = _resolveComponent("v-menu");
            return (_openBlock(), _createBlock(_component_v_menu, {
                class: "menu",
                style: _normalizeStyle(cssPosition.value),
                "model-value": isOpenMenu.value,
                transition: false,
                "onUpdate:modelValue": handleUpdateModel
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_list, { "data-cy": "list-control-contextmenu" }, {
                        default: _withCtx(() => [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuData, (menu, index) => {
                                return _createVNode(_component_v_list_item, {
                                    density: "compact",
                                    key: index,
                                    value: index,
                                    onClick: menu.eventHandler
                                }, {
                                    default: _withCtx(() => [
                                        (menu.icon)
                                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                                key: 0,
                                                size: "22",
                                                class: "mr-2"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(menu.icon), 1 /* TEXT */)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */))
                                            : _createCommentVNode("v-if", true),
                                        _createElementVNode("span", _hoisted_1, _toDisplayString(menu.title), 1 /* TEXT */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "onClick"]);
                            }), 64 /* STABLE_FRAGMENT */))
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["style", "model-value"]));
        };
    }
});
